module.exports = __webpack_public_path__ + "img/ic_flag_italy.0596a016.svg";